import * as types from './types';

const updateUserData = userData => ({
  type: types.UPDATE_USER_DATA,
  meta: {
    async: true,
    api: 'users',
    path: '/v1/users/me',
    body: userData,
    method: 'PATCH'
  }
});

const getUserData = () => ({
  type: types.GET_USER_DATA,
  meta: {
    async: true,
    api: 'users',
    path: '/v1/users/me',
    method: 'GET',
    blocking: false
  }
});

const resetUserData = () => ({
  type: types.RESET_USER_DATA
});

const resetFetch = () => ({
  type: types.RESET_FETCH
});

export { getUserData, updateUserData, resetUserData, resetFetch };
